export const replaceProtokol = (host: string) => {
  return host.replace('http://', '').replace('https://', '')
}
